import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=274d6478"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('274d6478')) {
      api.createRecord('274d6478', component.options)
    } else {
      api.reload('274d6478', component.options)
    }
    module.hot.accept("./Error.vue?vue&type=template&id=274d6478", function () {
      api.rerender('274d6478', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/base/Error.vue"
export default component.exports